import styled, { css } from 'styled-components';
import { aiTextColor, themeGet, themeGetColor } from 'modules/v2/foundation/theme';
import { responsiveProperty } from 'modules/v2/utils/responsiveProperty';
export const typographyBase = css `
  font-family: ${themeGet('fontFamily.default')};
`;
export const truncate = css `
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
const typographyDefaults = {
    $fontSize: 'medium',
    $fontWeight: 'regular',
    $fontStyle: 'normal',
    $lineHeight: 'default',
};
function getColor(props) {
    const { $appearance, $color } = props;
    if ($appearance === 'ai') {
        return aiTextColor('500');
    }
    const appearanceToColorMap = {
        '100': 'text.100',
        '200': 'text.200',
        '300': 'text.300',
        light: 'text.light',
        success: 'text.success',
        danger: 'text.danger',
        ai: 'text.ai',
    };
    if ($appearance) {
        return responsiveProperty('color', appearanceToColorMap[$appearance]);
    }
    if ($color) {
        return responsiveProperty('color', $color);
    }
    return themeGetColor('text.200');
}
export const Typography = styled.span.attrs((props) => (Object.assign(Object.assign({}, typographyDefaults), props))) `
  ${typographyBase};
  ${({ $fontSize }) => $fontSize && responsiveProperty('fontSize', $fontSize)};
  ${({ $fontWeight }) => $fontWeight && responsiveProperty('fontWeight', $fontWeight)};
  ${({ $fontStyle }) => $fontStyle && responsiveProperty('fontStyle', $fontStyle)};
  ${({ $lineHeight }) => $lineHeight && responsiveProperty('lineHeight', $lineHeight)};

  ${getColor};

  ${(props) => props.$truncate && truncate};
`;
const headingsBase = css `
  ${typographyBase};
  font-weight: 400;
  margin: 0;
  color: ${themeGet('colors.text.300')};
`;
export const H1 = styled.h1 `
  ${headingsBase};

  ${responsiveProperty('fontSize', {
    base: '1.75rem',
    sm: '2.25rem',
})};

  ${responsiveProperty('lineHeight', {
    base: '2.25rem',
    sm: '3rem',
})};

  ${(props) => props.$truncate && truncate};
`;
export const H2 = styled.h2 `
  ${headingsBase};

  ${responsiveProperty('fontSize', {
    base: '1.625rem',
    sm: '2rem',
})};

  ${responsiveProperty('lineHeight', {
    base: '2.125rem',
    sm: '2.75rem',
})};

  ${(props) => props.$truncate && truncate};
`;
export const H3 = styled.h3 `
  ${headingsBase};

  ${responsiveProperty('fontSize', {
    base: '1.5rem',
    sm: '1.75rem',
})};

  ${responsiveProperty('lineHeight', {
    base: '2rem',
    sm: '2.375rem',
})};

  ${(props) => props.$truncate && truncate};
`;
export const H4 = styled.h4 `
  ${headingsBase};

  ${responsiveProperty('fontSize', {
    base: '1.375rem',
    sm: '1.5rem',
})};

  ${responsiveProperty('lineHeight', {
    base: '1.875rem',
    sm: '2rem',
})};

  ${(props) => props.$truncate && truncate};
`;
export const H5 = styled.h5 `
  ${headingsBase};

  font-size: 1.25rem;
  line-height: 1.75rem;

  ${(props) => props.$truncate && truncate};
`;
export const H6 = styled.h6 `
  ${headingsBase};

  font-size: 1rem;
  line-height: 1.375rem;

  ${(props) => props.$truncate && truncate};
`;
